module.exports = __webpack_public_path__ + "img/head_h.bd1e2da5.png";